<script setup>
import { useRouter } from "vue-router";

const props = defineProps({
  title: String,
  description: String,
  icon: String,
  color: {
    type: String,
    default: "primary",
  },

  route: {
    type: String,
    default: null,
  },
});

const router = useRouter();

const handleClick = () => {
  if (props.route) {
    router.push(props.route);
  }
};
</script>
<template>
  <div
    class="card border-0 shadow-sm rounded-4 h-100 action-card"
    :class="{ 'cursor-pointer': !!route }"
    @click="handleClick"
  >
    <div class="card-body p-4">
      <div class="d-flex align-items-start justify-content-between mb-3">
        <div class="action-icon" :class="`text-${color}-subtle text-${color}`">
          <h6 class="fw-bold mb-2">
            <i :class="`bi ${icon}  me-1`"></i>{{ title }}
          </h6>
        </div>
        <i class="bi bi-arrow-right text-muted"></i>
      </div>
      <p class="text-muted small mb-0">{{ description }}</p>
    </div>
  </div>
</template>

<style scoped>
.action-card {
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

/* ✅ hover effect เมื่อ card คลิกได้ */
.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.12) !important;
}
</style>
